import { Navigate, Route } from "react-router-dom";
import ProtectedRoute from "../components/auth/ProtectedRoute";
import { ROUTES } from "../constants/routes";
// Layouts (imported but used by parent component)
// import HeaderLayout from "../components/layout/HeaderLayout";
// import HeaderFooterLayout from "../components/layout/HeaderFooterLayout";
// Pages
import About from "../pages/About";
// Dashboard
import Dashboard from "../pages/dashboard/Dashboard";
// Profile
// Games
import {
  CreateGame,
  EditGame,
  GameDetails,
  GameHistory,
  GameSuccess,
  GeneratingTeams,
  InviteMembers,
  ManageTeams,
  ReviewBooking,
  UpcomingGames,
} from "../pages/games";
// Groups
import { EditGroup, ViewGroup } from "../pages/groups";
import { Home } from "../pages/Home";
// Settings
// Payments
import ConnectingStripeAccount from "../pages/payments/ConnectingStripeAccount";
import EarningsAndPayouts from "../pages/payments/EarningsAndPayouts";
import Payments from "../pages/payments/index";
import MyPayments from "../pages/payments/MyPayments/MyPayments";
import PayoutGettingStarted from "../pages/payments/PayoutGettingStarted";
import SetupPayoutAccount from "../pages/payments/SetupPayoutAccount";
import EditProfile from "../pages/profile/EditProfile";
import MyProfile from "../pages/profile/MyProfile";
import SettingsDeleteAccount from "../pages/settings/DeleteAccount";
import SettingsEmail from "../pages/settings/Email";
import Settings from "../pages/settings/index";
import SettingsNotifications from "../pages/settings/Notifications";
import SettingsPassword from "../pages/settings/Password";
import SettingsPasswordCheckEmail from "../pages/settings/PasswordCheckEmail";

export const HeaderFooterRoutes = [
  <Route key="home" index element={<Home />} />,
  <Route key="about" path={ROUTES.ABOUT} element={<About />} />,
  // FE-4: marketing copy implies a /games discovery page; discovery actually
  // lives at /upcoming, so redirect instead of 404ing.
  <Route
    key="games-redirect"
    path="/games"
    element={<Navigate to={ROUTES.UPCOMING_GAMES} replace />}
  />,
];

export const HeaderOnlyRoutes = [
  <Route
    key="dashboard"
    path={ROUTES.DASHBOARD}
    element={
      <ProtectedRoute>
        <Dashboard />
      </ProtectedRoute>
    }
  />,
  <Route
    key="my-profile"
    path={ROUTES.MY_PROFILE}
    element={
      <ProtectedRoute>
        <MyProfile />
      </ProtectedRoute>
    }
  />,
  <Route
    key="edit-profile"
    path={ROUTES.EDIT_PROFILE}
    element={
      <ProtectedRoute>
        <EditProfile />
      </ProtectedRoute>
    }
  />,
  <Route
    key="settings"
    path={ROUTES.SETTINGS}
    element={
      <ProtectedRoute>
        <Settings />
      </ProtectedRoute>
    }
  />,
  <Route
    key="settings-email"
    path={ROUTES.SETTINGS_EMAIL}
    element={
      <ProtectedRoute>
        <SettingsEmail />
      </ProtectedRoute>
    }
  />,
  <Route
    key="settings-password"
    path={ROUTES.SETTINGS_PASSWORD}
    element={
      <ProtectedRoute>
        <SettingsPassword />
      </ProtectedRoute>
    }
  />,
  <Route
    key="settings-password-check"
    path={ROUTES.SETTINGS_PASSWORD_CHECK_EMAIL}
    element={
      <ProtectedRoute>
        <SettingsPasswordCheckEmail />
      </ProtectedRoute>
    }
  />,
  <Route
    key="settings-notifications"
    path={ROUTES.SETTINGS_NOTIFICATIONS}
    element={
      <ProtectedRoute>
        <SettingsNotifications />
      </ProtectedRoute>
    }
  />,
  <Route
    key="settings-delete"
    path={ROUTES.SETTINGS_DELETE_ACCOUNT}
    element={
      <ProtectedRoute>
        <SettingsDeleteAccount />
      </ProtectedRoute>
    }
  />,
  <Route
    key="payments"
    path={ROUTES.PAYMENTS}
    element={
      <ProtectedRoute>
        <Payments />
      </ProtectedRoute>
    }
  />,
  <Route
    key="my-payments"
    path={ROUTES.MY_PAYMENTS}
    element={
      <ProtectedRoute>
        <MyPayments />
      </ProtectedRoute>
    }
  />,
  <Route
    key="earnings"
    path={ROUTES.EARNINGS}
    element={
      <ProtectedRoute>
        <EarningsAndPayouts />
      </ProtectedRoute>
    }
  />,
  <Route
    key="setup-payout"
    path={ROUTES.SETUP_PAYOUT}
    element={
      <ProtectedRoute>
        <SetupPayoutAccount />
      </ProtectedRoute>
    }
  />,
  <Route
    key="payout-getting-started"
    path={ROUTES.PAYOUT_GETTING_STARTED}
    element={
      <ProtectedRoute>
        <PayoutGettingStarted />
      </ProtectedRoute>
    }
  />,
  <Route
    key="connect-stripe-account"
    path={ROUTES.CONNECT_STRIPE_ACCOUNT}
    element={
      <ProtectedRoute>
        <ConnectingStripeAccount />
      </ProtectedRoute>
    }
  />,
  <Route
    key="create-game"
    path={ROUTES.CREATE_GAME}
    element={
      <ProtectedRoute>
        <CreateGame />
      </ProtectedRoute>
    }
  />,
  <Route
    key="edit-game"
    path={ROUTES.EDIT_GAME}
    element={
      <ProtectedRoute>
        <EditGame />
      </ProtectedRoute>
    }
  />,
  <Route
    key="upcoming-games"
    path={ROUTES.UPCOMING_GAMES}
    element={
      // <ProtectedRoute>
      <UpcomingGames />
      // </ProtectedRoute>
    }
  />,
  <Route
    key="game-history"
    path={ROUTES.GAME_HISTORY}
    element={
      <ProtectedRoute>
        <GameHistory />
      </ProtectedRoute>
    }
  />,
  <Route
    key="game-success"
    path={ROUTES.GAME_SUCCESS}
    element={
      <ProtectedRoute>
        <GameSuccess />
      </ProtectedRoute>
    }
  />,
  <Route
    key="game-details"
    path={ROUTES.GAME_DETAILS}
    element={
      // <ProtectedRoute>
      <GameDetails />
      // </ProtectedRoute>
    }
  />,
  <Route
    key="review-booking"
    path={ROUTES.REVIEW_BOOKING}
    element={
      <ProtectedRoute>
        <ReviewBooking />
      </ProtectedRoute>
    }
  />,
  <Route
    key="generating-teams"
    path={ROUTES.GENERATING_TEAMS}
    element={
      <ProtectedRoute>
        <GeneratingTeams />
      </ProtectedRoute>
    }
  />,
  <Route
    key="manage-teams"
    path={ROUTES.MANAGE_TEAMS}
    element={
      <ProtectedRoute>
        <ManageTeams />
      </ProtectedRoute>
    }
  />,
  <Route
    key="invite-members"
    path={ROUTES.INVITE_MEMBERS}
    element={
      <ProtectedRoute>
        <InviteMembers />
      </ProtectedRoute>
    }
  />,
  <Route
    key="view-group"
    path={ROUTES.VIEW_GROUP}
    element={
      <ProtectedRoute>
        <ViewGroup />
      </ProtectedRoute>
    }
  />,
  <Route
    key="edit-group"
    path={ROUTES.EDIT_GROUP}
    element={
      <ProtectedRoute>
        <EditGroup />
      </ProtectedRoute>
    }
  />,
];
